// WARNING: there is a duplicate roles.js on the server side. An issue with transpiling/minifying dependencies precludes import the server version of roles
// the fix: upgrade create-react-app to an unejected version and add "import from outside src" feature

export const roles = {
  superadmin: {
    admin: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*'],
    },
    candidate: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    client: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    timesheet: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
  },
  consultant: {
    client: {
      'create:own': ['*'],
      'read:own': ['*'],
      'update:own': ['*'],
    },
    candidate: {
      'create:own': ['*'],
      'read:own': ['*'],
      'update:own': ['*'],
    },
    job: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    note: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
  },
  client: {
    candidate: {
      'read:own': ['*'],
    },
    job: {
      'read:own': ['*'],
      'update:own': ['*'],
    },
    timesheet: {
      'read:own': ['*'],
      'update:own': ['*'],
    },
    jobtype: {
      'read:any': ['*'],
    }
  },
  candidate: {
    account: {
      'read:own': ['*'],
      'update:own': ['*', '!role', '!userType', '!status', '!_id'],
    },
    timesheet: {
      'read:own': ['*']
    }
  }
};

export const roleInherits = [
  ['client', 'candidate'],
  ['consultant', ['client', 'candidate']],
  ['superadmin', ['consultant', 'client', 'candidate']]
]



// WEBPACK FOOTER //
// ./src/modules/access-control/roles.js